import { CheckCircle2 } from 'lucide-react';
import { useT } from '@/lib/i18n/useT';

export function FinishPage() {
  const t = useT();
  return (
    <div className="grid min-h-screen place-items-center bg-[var(--color-xk-navy)] p-6 text-center text-white">
      <div className="max-w-md space-y-4">
        <CheckCircle2 className="mx-auto h-16 w-16 text-[var(--color-accent-ink)]" />
        <h1 className="text-3xl font-bold">{t('publicSurvey.finishPage.title')}</h1>
        <p className="opacity-70">{t('publicSurvey.finishPage.body')}</p>
      </div>
    </div>
  );
}
